export class Vchalan {
  public CHDID!: number;
  public CH_FLOC!: number;
  public CH_TLOC!: number;
  public CH_NO!: string;
  public CH_REFNO!: string;
  public CH_DATE!: string;
  public CH_TIME!: string;
  public CH_FCITY!: string;
  public CH_TCITY!: string;
  public CH_STATUS!: string;
  public CH_VEHNO!: string;
  public CH_OWNER!: string;
  public CH_DRIVER!: string;
  public CH_NOT!: number;
  public CH_ADVAMT!: number;
  public CH_BALAMT!: number;
  public CH_TOTAMT!: number;
  public CH_TOTWT!: number;
  public CH_TOTPKG!: number;
  public CH_UID!: string;
  public CH_REMARK!: string;
  public CH_PUBLISH!: number;
  public CheckPoint!: string;
  public ArrivalDate!: string;
  public Remarks!: string;
  public CH_TYPE!: string;
  public CH_SETTSTATUS!: string;
  public CH_TRUCK_STATUS!: string;
  public CH_EXTRA_CHG!: number;
  public CH_EXTRA_WEIGHT!: number;
  public CH_OTH_CHG!: number;
  public CH_BAL_PAY!: number;
  public CH_TRUCK_REMARK!: string;
  public CH_ARRIVALNO!: string;
  public CH_ARRIVALDATE!: string;
  public CH_CONSNO!: string;
  public CH_ROUTE_BY!: string;
  public CH_ROUTE_TIME!: string;
  public CH_DRIVER2!: string;
  public CH_DRIVER1_ID!: number;
  public CH_DRIVER2_ID!: number;
  public CH_LOADEDBY!: number;
  public CH_TRUCK_HIRE!: number;
  public CH_VIA!: string;
  public CH_VIA_CHARGES!: number;
  public CH_BROKER_ID!: number;
  public CH_BROKER_NAME!: string;
  public CH_VEH_TYPE!: string;
  public CH_MOBILENO!: string;
  public CREATEDBY_USERID!: number;
  public UPDATEDBY_USERID!: number;
  public CREATED_DATE!: string;
  public UPDATED_DATE!: string;
  public IS_ACTIVE!: boolean;
}
